import { useCallback, useState } from 'react';

export const useFileItemState = () => {
  /**
   * all selected files to reingest
   */
  const [files, setFiles] = useState<Map<string, any>>(new Map());

  const addFile = useCallback(
    (key: string, value: any): void => setFiles((prevMap) => new Map(prevMap.set(key, value))),
    [],
  );

  const removeFile = useCallback(
    (key: string): void =>
      setFiles((prev) => {
        const state = new Map(prev);
        state.delete(key);
        return state;
      }),
    [],
  );

  const clearFiles = useCallback((): void => setFiles(new Map()), []);

  return {
    files,
    addFile,
    removeFile,
    clearFiles,
  };
};
